export default "__VITE_ASSET__jdpvgYP2__"